import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTarget24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTarget24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.96 1.351 19.576.2l-.858.858-2.632 2.632-.284.284.079.393.098.49a8.15 8.15 0 0 0-3.99-1.036 8.189 8.189 0 1 0 0 16.377 8.19 8.19 0 0 0 7.152-12.182l.487.098.393.078.284-.284 2.632-2.631.858-.858-1.15-.384-2.014-.671zm-2.53 3.116 1.49-1.49.406 1.217.119.356.356.118 1.217.406-1.49 1.49-1.748-.35zm1.249 7.543a6.69 6.69 0 0 1-6.69 6.688A6.689 6.689 0 1 1 16.16 6.78l-1.053 1.053a5.211 5.211 0 1 0 1.06 1.06L17.22 7.84a6.66 6.66 0 0 1 1.459 4.17m-6.69-3.711a3.7 3.7 0 0 1 2.04.61l-1.082 1.082a2.233 2.233 0 1 0 1.06 1.06L15.09 9.97a3.711 3.711 0 1 1-3.1-1.67m0 4.444a.733.733 0 1 0 0-1.467.733.733 0 0 0 0 1.467"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTarget24);
